
import React, {useState} from 'react'
import './Profile.css'
import ShowProfile from './showProfile'
import EditProfile from './editProfile'
import Grid from '@material-ui/core/Grid'
import profileImage from './images/image.jpeg';
import QuoteComponent from "./quoteComponent";
import MiniPostComponent from "./miniPost";
/*
In order to save the user data in the database,
you'll have to create a collection of Users in Firebase
where the specific user data will go.

Quick overview: data is split into documents, which is then
grouped into collections. This is very similar to MongoDB.

After the user has signed in with their email, Firebase will automatically
assign a specific ID to them. To store data from each user, you'll
have to extract that ID(you can find how to do that here:
  https://firebase.google.com/docs/auth/web/manage-users )
  *** In order for this to work, you have to import firebase
  from your firebase.js file!

If you'd like to create more data to be saved in the database, you
can add a combination of hooks, buttons, and inputs, in the same
way that we've added below for the photo.

Adding data to the database is simple enough, you can read docs
about it here: ( https://firebase.google.com/docs/firestore/manage-data/add-data )
*** Before you start this process, you'll have to add a Users collection on your Firebase console.
*/

export const Profile = () => {
	let [editProfile, setEditProfile] = useState(false);
	return (
		<React.Fragment>
			<div className = 'profile__container'>
			<Grid container spacing={3}>
				<Grid item xs={4}>
					<div>
						{editProfile ? (<EditProfile setEditProfile={setEditProfile}/>) : (<ShowProfile setEditProfile={setEditProfile}/>)}
					</div>
					<div className="imageContainer"><img src={profileImage}/></div>
				</Grid>
				<Grid item xs={8}>
					<div className="mainContainer">
						<div className="subContainer">
							<QuoteComponent/>
							<Grid container
							      direction="row"
							      justify="center"
							      alignItems="center">
								<MiniPostComponent/>
							</Grid>
						</div>
					</div>
				</Grid>
			</Grid>
			</div>
		</React.Fragment>
	)
}



